export const ptaContext = {
  channel: "PTA",
  type: "partner",
  mappings: [
    {
      key: "customerDashboard",
      useDefault: true,
      isGeneric: false,
      useReportingData: false,
      url: "/digital/servicing/pcsp-dashboard/partner-customer-dashboard",
      categoryId: "CUSTOMER_DASHBOARD",
      page_key: "DEFAULT",
      reportingData: {},
    },
    {
      key: "accountDashboard",
      useDefault: true,
      isGeneric: false,
      useReportingData: false,
      url: "/digital/servicing/pcsp-dashboard/partner-account-dashboard",
      categoryId: "ACCOUNT_DASHBOARD",
      page_key: "DEFAULT",
      reportingData: {},
    },
    {
      key: "cardCollections",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/digital/servicing/pcsp-dashboard/cardcollections",
      categoryId: "CARD_COLLECTIONS",
      page_key: "questionnaire",
      reportingData: {},
    },
  ],
};
